import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            实时追踪娱乐圈、网红圈最新爆料动态
          </p>

          <div className="relative pl-8 before:absolute before:left-[15px] before:top-2 before:bottom-2 before:w-px before:bg-background-300">
            {updates.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                <div className="absolute left-[-25px] top-1 w-[21px] h-[21px] rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-circle-fill text-[6px] text-background-50"></i>
                </div>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                  {item.tag && (
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '爆' ? 'bg-primary-100 text-primary-600' :
                      item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '最新' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-secondary-100 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <a href="#cards" className="text-sm md:text-base text-foreground-800 hover:text-primary-500 transition-colors duration-200 leading-relaxed cursor-pointer no-underline">
                  {item.title}
                </a>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="#cards"
              className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
            >
              查看更多快讯 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}